import { LicenseCardController } from './license-card.controller'

function licenseCard () {
  return {
    restrict: 'E',
    scope: {
      simplified: '<',
      size: '@'
    },
    templateUrl: '/admin/directives/license-card/license-card-directive.html?$$REVISION$$',
    controller: LicenseCardController
  }
}

export { licenseCard }
